module.exports = __webpack_public_path__ + "src/img/phoneTop.b808e9d9.png";